<template>
  <!-- <div
    id="app"
    class="w-full h-full font-poppins"> -->
  <div class="h-100 font-poppins">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
